import { format } from "date-fns";
import { InsuranceAttributesProps, PatientPhoneNumber } from "src/pages/addCase/types";


export const DEFAULT_PRESCRIPTION_VALUES = {
  drug_name: "EUFLEXXA",
  direction: "Inject 1 Euflexxa syringe into affected knee(s) weekly for 3 weeks.",
  is_specialty_pharmacy_only: false,
  note: "",
  written_date: format(new Date(), "MM/dd/yyyy"),
  injection_site: "",
  scheduled_date_of_service: "",
  diagnosis_code: [],
}

export const DEFAULT_CASE_VALUES = {
  mos: "online",
  submission_source: "provider",
  category: "medrx",
  prescription_attributes: DEFAULT_PRESCRIPTION_VALUES,
  case_attributes: {
    ship_to: "provider"
  },
  procedure_attributes: {
    cpt_code: "",
  },
  patient_attributes: {
    // retreatment_reminders: true,
    address: {
      address_name: "home",
    },
    phone_numbers: [
      {
        phone_type: "cell",
        id: null,
      } as PatientPhoneNumber,
    ],
  },
  insurances_attributes: [
    {
      global_insurance_id: null,
      is_primary_insurance: true,
      insurance_priority: 0,
    } as unknown as InsuranceAttributesProps,
  ],
}